"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("../../data/interfaces");
var moment = require("moment");
var getRulesByUserProfileType = function (rules, userProfileType) {
    var newRules;
    switch (userProfileType) {
        case interfaces_1.UserProfileType.Student:
            newRules = rules.student;
            break;
        case interfaces_1.UserProfileType.Staff:
            newRules = rules.staff;
            break;
        default:
            newRules = {};
            console.log("No rules were found for userProfileType: " + userProfileType);
            break;
    }
    return newRules;
};
exports.getRulesByUserProfileType = getRulesByUserProfileType;
var DELIMITER = "<<@>>";
exports.DELIMITER = DELIMITER;
var getPartsByDelimiter = function (value) {
    return value.split(DELIMITER);
};
exports.getPartsByDelimiter = getPartsByDelimiter;
var formatStandarUSDate = function (date) { return moment(date).utc().format("MM/DD/YYYY"); };
exports.formatStandarUSDate = formatStandarUSDate;
var ALLOWED_UPLOAD_DOCS_FORMAT = {
    csv: "text/csv",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    gif: "image/gif",
    jpegOrjpg: "image/jpeg",
    odp: "application/vnd.oasis.opendocument.presentation",
    ods: "application/vnd.oasis.opendocument.spreadsheet",
    odt: "application/vnd.oasis.opendocument.text",
    png: "image/png",
    pdf: "application/pdf",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    rtf: "application/rtf",
    txt: "text/plain",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
};
exports.ALLOWED_UPLOAD_DOCS_FORMAT = ALLOWED_UPLOAD_DOCS_FORMAT;
var DEFAULT_DEW_INFO = {
    campus: {
        id: 1,
        name: "Summerville",
        code: "C0",
        programs: [
            {
                id: 4,
                name: "HVAC",
                code: "HVAC",
                description: "",
                versionId: 4
            }
        ]
    }
};
exports.DEFAULT_DEW_INFO = DEFAULT_DEW_INFO;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2Z1bmN0aW9ucy9oZWxwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxvREFBcUQ7QUFDckQsK0JBQWlDO0FBRWpDLElBQU0seUJBQXlCLEdBQUcsVUFBQyxLQUFLLEVBQUUsZUFBZTtJQUNyRCxJQUFJLFFBQVEsQ0FBQTtJQUNaLFFBQVEsZUFBZSxFQUFFO1FBQ3JCLEtBQUssNEJBQWUsQ0FBQyxPQUFPO1lBQ3hCLFFBQVEsR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFBO1lBQ3hCLE1BQUs7UUFFVCxLQUFLLDRCQUFlLENBQUMsS0FBSztZQUN0QixRQUFRLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQTtZQUN0QixNQUFLO1FBRVQ7WUFDSSxRQUFRLEdBQUcsRUFBRSxDQUFBO1lBQ2IsT0FBTyxDQUFDLEdBQUcsQ0FBQyw4Q0FBNEMsZUFBaUIsQ0FBQyxDQUFBO1lBQzFFLE1BQUs7S0FDWjtJQUNELE9BQU8sUUFBUSxDQUFBO0FBQ25CLENBQUMsQ0FBQTtBQStDRyw4REFBeUI7QUE3QzdCLElBQU0sU0FBUyxHQUFHLE9BQU8sQ0FBQTtBQThDckIsOEJBQVM7QUE1Q2IsSUFBTSxtQkFBbUIsR0FBRyxVQUFDLEtBQUs7SUFDOUIsT0FBTyxLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxDQUFBO0FBQ2pDLENBQUMsQ0FBQTtBQTJDRyxrREFBbUI7QUF6Q3ZCLElBQU0sbUJBQW1CLEdBQUcsVUFBQyxJQUFJLElBQUssT0FBQSxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxFQUF2QyxDQUF1QyxDQUFBO0FBNEN6RSxrREFBbUI7QUExQ3ZCLElBQU0sMEJBQTBCLEdBQUc7SUFDL0IsR0FBRyxFQUFFLFVBQVU7SUFDZixHQUFHLEVBQUUsb0JBQW9CO0lBQ3pCLElBQUksRUFBRSx5RUFBeUU7SUFDL0UsR0FBRyxFQUFFLFdBQVc7SUFDaEIsU0FBUyxFQUFFLFlBQVk7SUFDdkIsR0FBRyxFQUFFLGlEQUFpRDtJQUN0RCxHQUFHLEVBQUUsZ0RBQWdEO0lBQ3JELEdBQUcsRUFBRSx5Q0FBeUM7SUFDOUMsR0FBRyxFQUFFLFdBQVc7SUFDaEIsR0FBRyxFQUFFLGlCQUFpQjtJQUN0QixHQUFHLEVBQUUsK0JBQStCO0lBQ3BDLElBQUksRUFBRSwyRUFBMkU7SUFDakYsR0FBRyxFQUFFLGlCQUFpQjtJQUN0QixHQUFHLEVBQUUsWUFBWTtJQUNqQixHQUFHLEVBQUUsMEJBQTBCO0lBQy9CLElBQUksRUFBRSxtRUFBbUU7Q0FDNUUsQ0FBQTtBQXdCRyxnRUFBMEI7QUF0QjlCLElBQU0sZ0JBQWdCLEdBQUc7SUFDckIsTUFBTSxFQUFFO1FBQ0osRUFBRSxFQUFFLENBQUM7UUFDTCxJQUFJLEVBQUUsYUFBYTtRQUNuQixJQUFJLEVBQUUsSUFBSTtRQUNWLFFBQVEsRUFBRTtZQUNOO2dCQUNJLEVBQUUsRUFBRSxDQUFDO2dCQUNMLElBQUksRUFBRSxNQUFNO2dCQUNaLElBQUksRUFBRSxNQUFNO2dCQUNaLFdBQVcsRUFBRSxFQUFFO2dCQUNmLFNBQVMsRUFBRSxDQUFDO2FBQ2Y7U0FDSjtLQUNKO0NBQ0osQ0FBQTtBQU1HLDRDQUFnQiJ9